// extracted by mini-css-extract-plugin
export var typingIndicator = "_nq-0";